import React from 'react';
import { ArrowRight, ArrowLeft } from 'lucide-react';
import './Hero.css';

const Hero = ({ t, isVisible, language }) => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const ArrowIcon = language === 'ar' ? ArrowLeft : ArrowRight;

  return (
    <section id="hero" className={`hero ${isVisible ? 'visible' : ''}`}>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">{t.hero.title}</h1>
          <p className="hero-subtitle">{t.hero.subtitle}</p>
          <p className="hero-description">{t.hero.description}</p>
          <button className="btn-primary" onClick={scrollToContact}>
            {t.hero.cta}
            <ArrowIcon size={20} />
          </button>
          <p className="hero-disclaimer">{t.hero.disclaimer}</p>
        </div>
        <div className="hero-image">
          <img 
            src="https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg" 
            alt="Professional consulting collaboration"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;